const ONE_SECOND_MS = 1000
const ONE_MINUTE_MS = 60 * ONE_SECOND_MS

export const SESSION_REFRESH_EXPIRATION_MS = ONE_MINUTE_MS
export const SESSION_REFRESH_RECENT_MS = 15 * ONE_SECOND_MS
export const SESSION_REFRESH_STATUS_LOCAL_STORAGE_KEY = 'session_refresh_status'
